<template>
  <div class="hello"> 
    <SeedJung_Header></SeedJung_Header>
    <div class="sc-fzsDOv">
      <div class="login-container">
        <h2 v-if="!showFindId && !showFindPw">로그인</h2>
        <form @submit.prevent="handleLogin" v-if="!showFindId && !showFindPw">
          <div class="form-group">
            <input type="text" v-model="username" placeholder="아이디" required>
          </div>
          <div class="form-group">
            <input type="password" v-model="password" placeholder="비밀번호" required>
          </div>
          <div class="login-options">
            <label class="custom-checkbox">
              <input type="checkbox" v-model="rememberMe">
              <span class="checkmark"></span>
              <span class="label-text">자동 로그인</span>
            </label>
            <div class="find-links">
              <a href="#" class="find-link" @click.prevent="showFindId = true">아이디 찾기</a>
              <span class="divider">|</span>
              <a href="#" class="find-link" @click.prevent="showFindPw = true">비밀번호 찾기</a>
            </div>
          </div>
          <button type="submit" class="login-btn">로그인</button>
          <p class="signup-link">계정이 없으신가요? <a href="/regist">회원가입</a></p>
        </form>
 
        <!-- 아이디 찾기 폼 -->
        <form v-if="showFindId" @submit.prevent="handleFindId" class="find-form">
          <h3>아이디 찾기</h3>
          <div class="form-group">
            <input type="text" v-model="findIdForm.nickname" placeholder="닉네임" required>
          </div>
          <div class="form-group">
            <input type="email" v-model="findIdForm.email" placeholder="이메일" required>
          </div>
          <div class="button-group">
            <button type="submit" class="login-btn">찾기</button>
            <button type="button" @click="showFindId = false" class="cancel-btn">취소</button>
          </div>
        </form>
 
        <!-- 비밀번호 찾기 폼 -->
        <form v-if="showFindPw" @submit.prevent="handleFindPw" class="find-form">
          <h3>비밀번호 찾기</h3>
          <div class="form-group">
            <input type="text" v-model="findPwForm.username" placeholder="아이디" required>
          </div>
          <div class="form-group">
            <input type="email" v-model="findPwForm.email" placeholder="이메일" required>
          </div>
          <div class="button-group">
            <button type="submit" class="login-btn">찾기</button>
            <button type="button" @click="showFindPw = false" class="cancel-btn">취소</button>
          </div>
        </form>
      </div>
    </div>
 
    <!-- 아이디 찾기 결과 팝업 -->
    <div class="popup-overlay" v-if="showFindIdResult">
      <div class="popup-content">
        <div class="popup-header">
          <h4>아이디 찾기 결과</h4>
        </div>
        <div class="popup-body">
          <p>가입하신 아이디는 <span class="highlight">{{ foundUsername }}</span> 입니다.</p>
        </div>
        <div class="popup-footer">
          <button @click="closePopup" class="popup-btn">확인</button>
        </div>
      </div>
    </div>
  </div>
 </template>

<script>
import SeedJung_Header from './SeedJung_Header.vue'
import axios from 'axios'

export default {
  name: 'SeedJung_Login',
  components: {
    SeedJung_Header
  },
  data() {
    return {
      username: '',
      password: '',
      errorMessage: '',
      rememberMe: false,
      showFindId: false,
      showFindPw: false,
      showFindIdResult: false,
      foundUsername: '',
      findIdForm: {
        nickname: '',
        email: ''
      },
      findPwForm: {
        username: '',
        email: ''
      }
    }
  },
  methods: {
    async handleLogin() {
      try {
        const response = await axios.post('/api/login', {
          username: this.username,
          password: this.password
        });
        
        if(response.data.message === '로그인 성공'){
          alert('로그인 성공');

          this.$store.dispatch('login', {
            user: response.data.user,
            token: response.data.token,
            rememberMe: this.rememberMe
          });

          this.$router.push('/');
        } else {
          alert(response.data.message);
        }
      } catch (error) {
        if (error.response) {
          if (error.response.status === 401) {
            alert(error.response.data.message);
          } else {
            alert('로그인 중 오류가 발생했습니다.');
          }
        } else if (error.request) {
          alert('서버로부터 응답을 받지 못했습니다.');
        } else {
          alert('로그인 요청을 보내는 중 오류가 발생했습니다.');
        }
        console.error('Login error:', error);
      }
    },
    async handleFindId() {
      try {
        const response = await axios.post('/api/find-id', this.findIdForm);
        if (response.data.success) {
          this.foundUsername = response.data.username;
          this.showFindIdResult = true;
          this.showFindId = false;
          this.findIdForm.email = '';
          this.findIdForm.nickname = '';
        }
      } catch (error) {
        alert('입력하신 정보와 일치하는 사용자를 찾을 수 없습니다.');
        console.error('Find ID error:', error);
      }
    },
    async handleFindPw() {
      try {
          const response = await axios.post('/api/find-password', this.findPwForm);
          console.log('Server response:', response.data); // 응답 확인용
          alert(response.data.message);
          if (response.data.success) {
              this.showFindPw = false;
          }
      } catch (error) {
          console.error('Find password error:', error.response?.data || error);
          alert(error.response?.data?.message || '서버 연결에 실패했습니다.');
      }
    },
    closePopup() {
      this.showFindIdResult = false;
      this.foundUsername = '';
    }
  }
}
</script>

<style scoped>
.sc-fzsDOv {
  margin-top: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - 170px);
  padding: 20px;
}

.login-container {
  background-color: #f0f0f0;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 400px;
}

h2, h3 {
  text-align: center;
  margin-bottom: 2rem;
  color: #333;
}

h2 {
  font-size: 1.8rem;
}

h3 {
  font-size: 1.5rem;
}

.form-group {
  margin-bottom: 1.5rem;
}

input {
  width: 100%;
  padding: 12px 15px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-size: 1rem;
  transition: border-color 0.3s ease;
}

input:focus {
  outline: none;
  border-color: #032f3e;
}

.login-options {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  padding: 0 0.5rem;
}

.custom-checkbox {
  display: flex;
  align-items: center;
  position: relative;
  cursor: pointer;
  user-select: none;
}

.custom-checkbox input {
  position: absolute;
  opacity: 0;
  width: auto;
}

.checkmark {
  position: relative;
  height: 18px;
  width: 18px;
  background-color: #fff;
  border: 2px solid #032f3e;
  border-radius: 4px;
  margin-right: 8px;
  transition: all 0.2s ease;
}

.custom-checkbox input:checked ~ .checkmark {
  background-color: #032f3e;
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
  left: 6px;
  top: 3px;
  width: 4px;
  height: 8px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.custom-checkbox input:checked ~ .checkmark:after {
  display: block;
}

.label-text {
  color: #666;
  font-size: 0.9rem;
}

.find-links {
  display: flex;
  align-items: center;
  gap: 8px;
}

.find-link {
  color: #666;
  font-size: 0.9rem;
  text-decoration: none;
  transition: color 0.2s;
}

.find-link:hover {
  color: #032f3e;
  text-decoration: underline;
}

.divider {
  color: #ccc;
  font-size: 0.9rem;
}

.button-group {
  display: flex;
  gap: 10px;
}

.login-btn, .cancel-btn {
  width: 100%;
  padding: 12px;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.3s;
}

.login-btn {
  background-color: #032f3e;
  color: white;
}

.login-btn:hover {
  background-color: #072c53;
}

.cancel-btn {
  background-color: #666;
  color: white;
}

.cancel-btn:hover {
  background-color: #555;
}

.signup-link {
  text-align: center;
  margin-top: 1.5rem;
  font-size: 1.2rem;
  color: #666;
}

.signup-link a {
  color: #032f3e;
  text-decoration: none;
  font-weight: bold;
}

.signup-link a:hover {
  text-decoration: underline;
}

.find-form {
  animation: slideIn 0.3s ease-out;
}

/* 팝업 스타일 */
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.popup-content {
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 90%;
  max-width: 400px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.popup-header {
  text-align: center;
  margin-bottom: 20px;
}

.popup-header h4 {
  font-size: 1.2rem;
  color: #333;
  margin: 0;
}

.popup-body {
  text-align: center;
  margin-bottom: 20px;
}

.highlight {
  color: #032f3e;
  font-weight: bold;
}

.popup-footer {
  text-align: center;
}

.popup-btn {
  background-color: #032f3e;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;
  transition: background-color 0.3s;
}

.popup-btn:hover {
  background-color: #072c53;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (min-width: 1024px) {
  .sc-fzsDOv {
    margin-top: 100px;
  }

  .login-container {
    max-width: 500px;
    padding: 2.5rem;
  }

  input, .login-btn {
    font-size: 1.1rem;
  }

  h2 {
    font-size: 2rem;
  }
}

@media (max-width: 768px) {
  .sc-fzsDOv {
    margin-top: 20px;
    min-height: calc(100vh - 85px);
  }

  .login-container {
    padding: 1.5rem;
    box-shadow: none;
    background-color: transparent;
  }

  h2 {
    font-size: 2.2rem;
  }

  input {
    font-size: 16px;
  }

  .login-btn {
    padding: 15px;
    font-size: 1.3rem;
  }
  
  .signup-link {
    font-size: 1.4rem;
  }

  .login-options {
    margin-bottom: 2rem;
  }

  .label-text {
    font-size: 1rem;
  }

  .find-link {
    font-size: 1rem;
  }

  .checkmark {
    height: 15px;
    width: 15px;
  }

  .checkmark:after {
    left: 4px;
    top: 1px;
    width: 4px;
    height: 9px;
  }
}
</style>